import { isArray } from "lodash";
import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus.js";
import { download } from "../../../functions/download.js";
import { errorDispatch } from "../../../functions/errorDispatch.js";
import { setDocTitle } from "../../../functions/HelperFuncs.js";
import { userHasAllRights } from "../../../functions/userRights.js";

export default {
  props: {
    mySpace: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: this.$options.name,
      files: [],
      doneSearching: false,
      selectedFiles: [],
      selectedFolders: [],
      folderInfo: {},
      folderId: this.$route.params.id,
      parentUrl: "",
    };
  },

  created() {
    //get files
    this.getFiles();

    EventBus.$on(`${this.id}-update`, () => {
      this.getFiles();
    });

    EventBus.$on(`files-holder-update`, (data) => {
      //update selected files and folders
      Object.keys(data).forEach((key) => {
        if (data[key] && this[key]) {
          this[key] = data[key];
        }
      });
    });
  },

  methods: {
    getFiles() {
      this.doneSearching = false;

      //use for adding folder details to adjust the back button
      if (this.folderId !== "null" && this.folderId) {
        this.$axios
          .get(
            `${baseUrl}/folderdetail?folder=${this.folderId}&myspace=${this.mySpace}`,
            {
              responseType: "json",
            }
          )
          .then((r) => {
            if (!isArray(r.data)) {
              this.folderInfo = r.data;

              //set title
              setDocTitle(this.folderInfo.name, this);

              this.createParentUrl(this.folderInfo);
            } else {
              this.folderInfo = {};
            }
          })
          .catch((e) => {
            errorDispatch("get_files");
          });
      } else {
        //is first page of space
        this.folderInfo = { name: "My Space" };

        //set title
        setDocTitle(this.folderInfo.name, this);

        //return to spaces
        this.parentUrl = `/${this.$store.state.company}/spaces`;
      }

      this.$axios
        .get(
          baseUrl + `/folder?folder=${this.folderId}&myspace=${this.mySpace}`,
          {
            responseType: "json",
          }
        )
        .then((r) => {
          this.files = r.data;

          this.doneSearching = true;
        });
    },
    createParentUrl(data) {
      if (data.parent_id !== undefined && data.parent_id) {
        //is other folder
        this.parentUrl = `/${this.$store.state.company}/${
          this.mySpace == 1 ? "myspace" : "home"
        }/expanded/${data.parent_id}`;
      } else {
        //is space
        this.parentUrl = `/${this.$store.state.company}/spaces`;
      }
    },
    createDownloadLink() {
      let downloadLink = `${baseUrl}/download?`;

      if (
        this.selectedFiles.length === 1 &&
        this.selectedFolders.length === 0
      ) {
        downloadLink += `file=${this.selectedFiles[0]}`;
      } else {
        downloadLink += `folders=${JSON.stringify(this.selectedFolders)}`;
        downloadLink += `&files=${JSON.stringify(this.selectedFiles)}`;
      }

      downloadLink += `&company=${this.$store.state.company}`;
      downloadLink += `&myspace=${this.mySpace}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },

    downloadSelected(e) {
      download(
        {
          type: "multi",
          items: {
            selectedFiles: this.selectedFiles,
            selectedFolders: this.selectedFolders,
          },
          btn: e.target,
        },
        this
      );

      //reset selected
      this.selectedFiles = [];
      this.selectedFolders = [];

      EventBus.$emit("files-holder-select-all", { checked: false });
    },
    transferSelected() {
      //set transfering mode
      this.$store.state.isTransfering = true;

      //get selected files for transfer
      this.$store.state.transferItems = {
        selectedFiles: this.selectedFiles,
        selectedFolders: this.selectedFolders,
        collection: [],
      };

      //got to the url
      this.$router.push(`/${this.$store.state.company}/mobile-transfer/ready`);
    },
    collectSelected() {
      if (this.$store.state.user) {
        EventBus.$emit("openOverlayPage", {
          id: "collect-file",
          selectedFiles: this.selectedFiles,
          selectedFolders: this.selectedFolders,
        });
      } else {
        //add to download for selected
        const newCollectForDownload = [...this.$store.state.collectForDownload];
        const selectedFiles = [...this.selectedFiles];

        selectedFiles.forEach((fileId) => {
          const fileWithData = this.files.filter(
            (fullFile) => fullFile.id === fileId
          )[0];

          if (
            !newCollectForDownload.filter((col) => col.id === fileId).length
          ) {
            //not found in array so push
            newCollectForDownload.push(fileWithData);
          }
        });

        //reset selected
        this.selectedFiles = [];
        this.selectedFolders = [];

        localStorage.setItem(
          "collectForDownload",
          JSON.stringify(newCollectForDownload)
        );

        this.$store.state.collectForDownload = newCollectForDownload;

        //reset selected
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collection: [],
        };

        EventBus.$emit(`${this.id}-update`);
      }
    },
  },
  computed: {
    title() {
      return this.folderInfo.name ? this.folderInfo.name : "files";
    },
    canAddFolder() {
      return !userHasAllRights(["create_folders"], this);
    },
  },
  watch: {
    $route() {
      this.folderId = this.$route.params.id;

      //update files
      this.getFiles();
    },
  },
};
